import React from 'react';
import { useLanguageStore } from '../store';

export const TermsPage = () => {
  const { language } = useLanguageStore();

  return (
    <div className="container-custom py-16 text-left max-w-4xl select-text">
      {/* РУССКИЙ */}
      {language === 'ru' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">УСЛОВИЯ ИСПОЛЬЗОВАНИЯ</h1>
          <p className="text-sm text-muted-foreground">Последнее обновление: 12 августа 2026 г.</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Данные предпринимателя и представительств</h2>
            <p>
              Сайт управляется частным предпринимателем <strong>Oksana Fedyk</strong> (коммерческое имя <strong>FEDYK Furniture</strong>).<br />
              <strong>Адрес (Бельгия):</strong> A. de Boecklaan 43, 1780 Wemmel, Belgium<br />
              <strong>Номер KBO / BTW:</strong> BE1024640395<br />
              <strong>E-mail:</strong> <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a><br />
              <strong>Телефон:</strong> +32 495 56 22 55
            </p>
            <p><strong>Представительства в ЕС:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>Румыния:</strong> FEDYK FURNITURE S.R.L. (București, RO52973961)</li>
              <li><strong>Ирландия:</strong> Deise Shipping Limited (Dublin, IE9702158E)</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Интеллектуальная собственность</h2>
            <p>
              Все материалы сайта (3D-конфигурации, фотографии продуктов, чертежи, логотипы, тексты) защищены авторским правом и принадлежат FEDYK Furniture.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Применимое право</h2>
            <p>
              Все условия регулируются <strong>законодательством Бельгии</strong>. Споры подлежат рассмотрению в нидерландоязычных судах округа Брюссель (Brussel, België).
            </p>
          </section>
        </article>
      )}

      {/* НИДЕРЛАНДСКИЙ */}
      {language === 'nl' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">ALGEMENE VOORWAARDEN</h1>
          <p className="text-sm text-muted-foreground">Laatst bijgewerkt: 12 augustus 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Identiteit van de onderneming</h2>
            <p>
              Eenmanszaak van <strong>Oksana Fedyk</strong> (commerciële naam <strong>FEDYK Furniture</strong>)<br />
              <strong>Adres:</strong> A. de Boecklaan 43, 1780 Wemmel, België<br />
              <strong>Ondernemingsnummer (KBO / BTW):</strong> BE1024640395<br />
              <strong>E-mail:</strong> <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a><br />
              <strong>Telefoon:</strong> +32 495 56 22 55
            </p>
            <p><strong>Europese vertegenwoordiging:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>Roemenië:</strong> FEDYK FURNITURE S.R.L. (Boekarest, RO52973961)</li>
              <li><strong>Ierland:</strong> Deise Shipping Limited (Dublin, IE9702158E)</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Intellectuele eigendomsrechten</h2>
            <p>
              Alle inhoud op deze website (teksten, 3D-modellen, foto's, ontwerpen, logo's) is eigendom van FEDYK Furniture.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Toepasselijk recht</h2>
            <p>
              Op deze voorwaarden is uitsluitend het <strong>Belgisch recht</strong> van toepassing. Geschillen vallen onder de bevoegdheid van de Nederlandstalige rechtbanken van Brussel.
            </p>
          </section>
        </article>
      )}

      {/* АНГЛИЙСКИЙ */}
      {language === 'en' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">TERMS OF SERVICE</h1>
          <p className="text-sm text-muted-foreground">Last updated: August 12, 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Business Identity</h2>
            <p>
              <strong>FEDYK Furniture</strong> (represented by <strong>Oksana Fedyk</strong>, Self-employed)<br />
              <strong>Address:</strong> A. de Boecklaan 43, 1780 Wemmel, Belgium<br />
              <strong>Enterprise Number (VAT):</strong> BE1024640395<br />
              <strong>E-mail:</strong> <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a><br />
              <strong>Phone:</strong> +32 495 56 22 55
            </p>
            <p><strong>European Representatives:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>Romania:</strong> FEDYK FURNITURE S.R.L. (Bucharest, RO52973961)</li>
              <li><strong>Ireland:</strong> Deise Shipping Limited (Dublin, IE9702158E)</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Intellectual Property</h2>
            <p>
              All contents of this website (texts, 3D configurations, photos, designs) are protected by copyright and owned by FEDYK Furniture.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Governing Law</h2>
            <p>
              These terms are governed by the <strong>laws of Belgium</strong>. Disputes shall be submitted to the competent courts of Brussels, Belgium.
            </p>
          </section>
        </article>
      )}

      {/* РУМЫНСКИЙ */}
      {language === 'ro' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">TERMENI ȘI CONDIȚII</h1>
          <p className="text-sm text-muted-foreground">Ultima actualizare: 12 august 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Identitatea Întreprinderii</h2>
            <p>
              Întreprindere Individuală <strong>Oksana Fedyk</strong> (denumire comercială <strong>FEDYK Furniture</strong>)<br />
              <strong>Adresă:</strong> A. de Boecklaan 43, 1780 Wemmel, Belgia<br />
              <strong>CUI / CVA:</strong> BE1024640395<br />
              <strong>E-mail:</strong> <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a><br />
              <strong>Telefon:</strong> +32 495 56 22 55
            </p>
            <p><strong>Reprezentanțe Europene:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>România:</strong> FEDYK FURNITURE S.R.L. (București, RO52973961)</li>
              <li><strong>Irlanda:</strong> Deise Shipping Limited (Dublin, IE9702158E)</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Proprietate Intelectuală</h2>
            <p>
              Toate materialele de pe acest site (configurații 3D, fotografii, modele) sunt protejate de drepturile de autor și aparțin FEDYK Furniture.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Legea Aplicabilă</h2>
            <p>
              Acești termeni sunt guvernați de <strong>legislația din Belgia</strong>. Eventualele litigii vor fi soluționate de instanțele competente din Bruxelles, Belgia.
            </p>
          </section>
        </article>
      )}
    </div>
  );
};

export default TermsPage;
